var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "field_total" }, [
    _c("div", { staticClass: "field_static_width field_total_" }, [
      _vm._v("\n        Всього\n    "),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "dolznost field_total_" }),
    _vm._v(" "),
    _c("div", { staticClass: "shtat field_total_" }, [
      _vm._v("\n        " + _vm._s(_vm.field.shtat) + "\n    "),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "field_total_ big" }),
    _vm._v(" "),
    _c("div", { staticClass: "field_total_ medium" }),
    _vm._v(" "),
    _c("div", { staticClass: "field_total_ small" }),
    _vm._v(" "),
    _c("div", { staticClass: "field_total_ big" }),
    _vm._v(" "),
    _c("div", { staticClass: "field_total_ medium_10" }),
    _vm._v(" "),
    _c("div", { staticClass: "field_total_ medium" }),
    _vm._v(" "),
    _c("div", { staticClass: "field_total_ medium_10" }),
    _vm._v(" "),
    _c("div", { staticClass: "field_total_ last_child" }, [
      _vm._v(
        "\n        " +
          _vm._s(_vm._f("toNiceNumber")(_vm.field.all_fop)) +
          "\n    "
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "clr" }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }